<form [formGroup]="accommodationForm" autocomplete="off">
    <div class="step-container">
    
  <div class="step-title">
    {{ isEditable ? getTranslation('accommodation.title') : getTranslation('accommodation.blockedForEdit') }}
    <span *ngIf="!isEditable" class="badge badge-warning ml-2" style="font-size: 0.75rem;">(Read Only)</span>
  </div>
  
      <div *ngIf="isJsonShow">
        <span>{{ accommodationForm.value | json }}</span>
      </div>
  
      <div class="row gx-2">
        <!-- Housing Preference -->
        <div class="form-group col-12 col-md-6 mb-3">
          <label class="form-label">{{ getTranslation('accommodation.housingPreference.label') }}<span class="text-danger">*</span></label>
          <select class="form-control" id="inputHousingPreference" formControlName="HousingPreference">
            <option value="" disabled selected>{{ getTranslation('common.select') }}</option>
            <option value="Dorm">{{ getTranslation('accommodation.housingPreference.options.dorm') }}</option>
            <option value="Double">{{ getTranslation('accommodation.housingPreference.options.double') }}</option>
            <option value="DoubleAC">{{ getTranslation('accommodation.housingPreference.options.doubleAc') }}</option>
            <option value="Single">{{ getTranslation('accommodation.housingPreference.options.single') }}</option>
            <option value="SingleAC">{{ getTranslation('accommodation.housingPreference.options.singleAc') }}</option>
          </select>
          <div *ngIf="submitted && accommodationForm.get('HousingPreference')?.invalid" class="text-danger">
            {{ getTranslation('accommodation.validation.housingPreferenceRequired') }}
          </div>
        </div>
  
        <!-- Snore Question -->
        <div class="form-group col-12 col-md-6 mb-3">
          <label class="form-label" [ngClass]="{'text-danger': accommodationForm.controls['HasSnoreHabit'].invalid && submitted}">{{ getTranslation('accommodation.snoreQuestion') }}<span class="text-danger">*</span></label>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="snoreYes" formControlName="HasSnoreHabit" [value]="true">
              <label class="form-check-label" for="snoreYes">{{ getTranslation('common.yes') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="snoreNo" formControlName="HasSnoreHabit" [value]="false">
              <label class="form-check-label" for="snoreNo">{{ getTranslation('common.no') }}</label>
            </div>
          </div>
          <div *ngIf="submitted && accommodationForm.get('HasSnoreHabit')?.invalid" class="text-danger">
            {{ getTranslation('accommodation.validation.snoreRequired') }}
          </div>
        </div>
      </div>
  
      <div class="row gx-2">
        <!-- Concerns about roommates -->
        <div class="form-group col-12 col-md-6 mb-3">
          <label class="form-label" [ngClass]="{'text-danger': accommodationForm.controls['HasConcernsWithRoommates'].invalid && submitted}">{{ getTranslation('accommodation.roommateConcernQuestion') }}<span class="text-danger">*</span></label>
          <div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="concernYes" formControlName="HasConcernsWithRoommates" [value]="true">
              <label class="form-check-label" for="concernYes">{{ getTranslation('common.yes') }}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="concernNo" formControlName="HasConcernsWithRoommates" [value]="false">
              <label class="form-check-label" for="concernNo">{{ getTranslation('common.no') }}</label>
            </div>
          </div>
          <div *ngIf="submitted && accommodationForm.get('HasConcernsWithRoommates')?.invalid" class="text-danger">
            {{ getTranslation('accommodation.validation.roommateConcernRequired') }}
          </div>
        </div>
  
        <!-- If concerns about roommates -->
        <div class="form-group col-12 col-md-6 mb-3" *ngIf="accommodationForm.get('HasConcernsWithRoommates')?.value === true">
          <label for="inputDescribeConcerns" class="form-label">{{ getTranslation('accommodation.describeConcerns') }}</label>
          <textarea class="form-control" id="inputDescribeConcerns" formControlName="DescribeConcerns" [placeholder]="getTranslation('placeholder.enterDetails')"></textarea>
        </div>
      </div>
  
      <div class="row gx-2">
        <!-- Requests related to accommodations -->
        <div class="form-group col-12 mb-3">
          <label for="inputAccommodationRequests" class="form-label">{{ getTranslation('accommodation.otherRequests') }}</label>
          <textarea class="form-control" id="inputAccommodationRequests" formControlName="OtherAccommodationRequests" [placeholder]="getTranslation('accommodation.placeholder.enterRequests')"></textarea>
        </div>
      </div>
  
    </div>
    <!-- Buttons -->
     <!-- Buttons start -->
  <div class="btn-group vendortitle nb-progress-bar margincss mobile-responsive" 
       *ngIf="!isPreviewMode && isEditable">
    <button type="button" class="btn savedraftbtn" 
            *ngIf="accommodationForm.get('SaveMode')?.value !== SaveMode.SAVE"
            (click)="onSubmit(SaveMode.DRAFT)">
      <i class="fas fa-save mr-2"></i>{{ getTranslation('button.saveAsDraft') }}
    </button>
    <button type="button" class="btn prevbtn" (click)="goToBack()">
      <i class="fas fa-arrow-left mr-2"></i>{{ getTranslation('button.previous') }}
    </button>
    <button type="button" class="btn nextbtn" (click)="onSubmit(SaveMode.SAVE)">
      <i class="fas fa-arrow-right mr-2"></i>{{ getTranslation('button.next') }}
    </button>
  </div>
  <!-- Buttons ends -->
  </form>
  